import { Component, inject, input, signal, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'placeholder',
  imports: [],
  templateUrl: './placeholder.component.html',
  styleUrl: './placeholder.component.scss',
})
export class PlaceholderComponent implements OnInit {
  private route = inject(ActivatedRoute);

  // NOTE :: ON USING AS COMPONENT NOT A ROUTER
  readonly activeTypeMenu = input('');

  typeMenu = signal('');
  menus = signal<{ title: string; icon: string }[]>([]);

  ngOnInit(): void {
    if (this.route.data) {
      this.route.data.subscribe({
        next: typeMenu => {
          const activeTypeMenu = this.activeTypeMenu();
          if (activeTypeMenu) {
            this.typeMenu.set(activeTypeMenu);
          } else {
            this.typeMenu.set(typeMenu['typeMenu']);
          }
          if (this.typeMenu() === 'Desk') {
            this.menus.set(this.getDeskPlaceholderMenus());
          } else if (this.typeMenu() === 'Admin') {
            this.menus.set(this.getAdminPlaceholderMenus());
          } else if (this.typeMenu() === 'Market') {
            this.menus.set(this.getMarketPlaceholderMenus());
          }
        },
      });
    }
  }

  private getDeskPlaceholderMenus(): { title: string; icon: string }[] {
    return [
      {
        icon: 'gear',
        title: 'Operation',
      },
      {
        icon: 'users-between-lines',
        title: 'Client',
      },
      {
        icon: 'credit-card',
        title: 'Credit',
      },
    ];
  }

  private getAdminPlaceholderMenus(): { title: string; icon: string }[] {
    return [
      {
        icon: 'users',
        title: 'Operator',
      },
      {
        icon: 'user-tag',
        title: 'Roles',
      },
      {
        icon: 'shield-halved',
        title: 'Secure',
      },
      {
        icon: 'bell',
        title: 'Notification',
      },
    ];
  }

  private getMarketPlaceholderMenus(): { title: string; icon: string }[] {
    return [
      {
        title: `Payment reports`,
        icon: 'file-excel',
      },
      {
        title: `Manage products`,
        icon: 'box',
      },
      {
        title: `Statements`,
        icon: 'history',
      },
      {
        title: `Transfer`,
        icon: 'paper-plane',
      },
    ];
  }
}
